<template>
  <div class="pagination-controls">
    <div class="pagination-controls_label">
      {{ pageItemStartIndex }} - {{ pageItemEndIndex }} of {{ totalItems }}
    </div>
    <div class="pagination-controls_btn-wrapper">
      <button
        type="button"
        class="pagination-controls_btn pagination-controls_btn_prev"
        name="prev-btn"
        aria-label="Previous Page of Providers"
        :disabled="pageNumber === 0"
        @click="$emit('prev-click')"
      >
        <i class="vcore_icon icon-chevron_left"></i>
      </button>
      <button
        type="button"
        class="pagination-controls_btn pagination-controls_btn_next"
        name="next-btn"
        aria-label="Next Page of Providers"
        :disabled="pageNumber >= pageCount - 1"
        @click="$emit('next-click')"
      >
        <i class="vcore_icon icon-chevron_right"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "PaginationControls",
  props: {
    totalItems: {
      type: Number,
      required: true,
    },
    pageSize: {
      type: Number,
      required: true,
    },
    pageNumber: {
      type: Number,
      required: true,
    },
    pageCount: {
      type: Number,
      required: true,
    },
  },
  computed: {
    pageItemStartIndex() {
      return this.pageSize * this.pageNumber + 1;
    },
    pageItemEndIndex() {
      const possibleEndIndex = this.pageItemStartIndex + (this.pageSize - 1);
      if (possibleEndIndex > this.totalItems) {
        return this.totalItems;
      }
      return this.pageItemStartIndex + (this.pageSize - 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.pagination-controls_label {
  display: inline-block;
  font-size: 14px;
  font-weight: bold;
  margin-right: 20px;

  @media (max-width: $grid-breakpoint-sm) {
    font-size: 18px;
  }
}

.pagination-controls_btn-wrapper {
  display: inline-block;
}

.pagination-controls_btn {
  padding: 4px;
  border: none;
  font: inherit;
  color: $color_dark-blue;
  background: none;
  border: 1px solid $color_dark-blue;
  cursor: pointer;

  @media (max-width: $grid-breakpoint-sm) {
    font-size: 18px;
  }

  &:hover {
    background-color: $color_dark-blue;
    color: $color_white;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.pagination-controls_btn_prev {
  margin-right: 4px;
}
</style>
